import React from "react";
import { Link } from "react-router-dom";
import Container from "../components/ui/Container/Container";
import PageHeading from "../components/ui/PageHeading/PageHeading";
import { Route } from "../routes";
import { useAuthContext } from "../context/auth-context";

const SettingsPage: React.FC = () => {
  const { user } = useAuthContext();

  if (!user || (user.role !== 'ADMIN' && user.role !== 'SUPERADMIN')) {
    return <Container><p>Access denied.</p></Container>;
  }

  const settingsLinks = [
    { label: "Agents", to: Route.organizations, description: "Manage partner organizations and their users." },
    // { label: "Users", to: Route.users, description: "Manage system users, roles, and permissions." },
    { label: "Stations", to: Route.stations, description: "View and refresh station contact data from Wheels." },
    { label: "Header Links", to: Route.headerLinks, description: "Configure links in the navigation header." },
    { label: "Widgets", to: Route.infoWidgets, description: "Manage content widgets." },
    { label: "Audit Trails", to: Route.auditTrails, description: "View history of changes to organizations and users." },
    { label: "Availability", to: Route.availabilityDebug, description: "View debug information about availability in Memcache and Task Queue." },
    { label: "API Documentation", to: Route.apiDocs, description: "Interactive OpenAPI / Swagger documentation and sandbox for B2B developers." },
  ];

  return (
    <>
      <PageHeading>Settings</PageHeading>
      <Container>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.5rem', marginTop: '1rem' }}>
          {settingsLinks.map(link => (
            <Link 
              key={link.to} 
              to={link.to} 
              style={{ 
                display: 'block', 
                padding: '1.5rem', 
                textDecoration: 'none', 
                color: 'inherit', 
                border: '1px solid #eee', 
                borderRadius: '8px',
                transition: 'all 0.2s ease',
                background: '#fff',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
              }}
              onMouseOver={e => {
                e.currentTarget.style.borderColor = '#007bff';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.borderColor = '#eee';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
              }}
            >
              <h3 style={{ margin: '0 0 0.5rem 0', color: '#007bff' }}>{link.label}</h3>
              <p style={{ margin: 0, opacity: 0.7, fontSize: '0.9rem' }}>{link.description}</p>
            </Link>
          ))}
        </div>
      </Container>
    </>
  );
};

export default SettingsPage;